var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-layout"},[_c('layout-header',{attrs:{"menu-is-open":_vm.menuIsOpen},on:{"toggleNav":_vm.toggleNav}}),_c('div',{staticClass:"main-container"},[_c('layout-sidebar',{attrs:{"menu-is-open":_vm.menuIsOpen},on:{"toggleNav":_vm.toggleNav}}),_c('div',{staticClass:"content"},[_vm._t("default")],2)],1),_c('layout-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }